import { render, staticRenderFns } from "./AppointmentStateChip.vue?vue&type=template&id=63310fed&scoped=true"
import script from "./AppointmentStateChip.vue?vue&type=script&lang=js"
export * from "./AppointmentStateChip.vue?vue&type=script&lang=js"
import style0 from "./AppointmentStateChip.vue?vue&type=style&index=0&id=63310fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63310fed",
  null
  
)

export default component.exports